import React from 'react';

export function PrintIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M38 16h-2V6H12v10h-2c-3.32 0-6 2.68-6 6v12h8v8h24v-8h8V22c0-3.32-2.68-6-6-6zm-22-6h16v6H16v-6zm16 24v4H16v-8h16v4zm4-4v-4H12v4H8v-8c0-1.1.9-2 2-2h28c1.1 0 2 .9 2 2v8h-4z" />
      <path d="M36 25a2 2 0 100-4 2 2 0 000 4z" />
    </svg>
  );
}
